import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["variant", "size", "leftIcon", "rightIcon", "nonActive", "hasNotice", "isLoading", "fullWidth", "className", "children"],
      _excluded2 = ["variant", "size", "leftIcon", "rightIcon", "nonActive", "hasNotice", "isLoading", "fullWidth", "className", "classNames", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { forwardRef, useMemo } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Button = _ref => {
  let {
    variant: srcVariant = 'primary',
    size = 'medium',
    leftIcon,
    rightIcon,
    nonActive = false,
    hasNotice = false,
    isLoading = false,
    fullWidth = false,
    className = '',
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const hasContent = Boolean(children);
  const hasSideIcon = Boolean(leftIcon || rightIcon);
  const variantClasses = useMemo(() => {
    const variants = Array.isArray(srcVariant) ? srcVariant : [srcVariant];
    return variants.filter(Boolean).map(variant => styles[`button--${variant}`]);
  }, [srcVariant]);
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    className: clsx(styles.button, ...variantClasses, nonActive ? styles[`button--nonActive`] : '', !hasSideIcon && styles[`button--${size}`], hasSideIcon ? styles[`button--${size}Icon`] : '', hasNotice ? styles[`button--notice`] : '', fullWidth && styles['button--fullWidth'], className)
  }, props), {}, {
    children: [leftIcon && /*#__PURE__*/_jsx("span", {
      className: clsx(styles.icon, hasContent ? styles['icon--left'] : ''),
      children: leftIcon
    }), isLoading ? /*#__PURE__*/_jsx(CircularProgress, {
      size: 16,
      color: "inherit"
    }) : children, rightIcon && /*#__PURE__*/_jsx("span", {
      className: clsx(styles.icon, hasContent ? styles['icon--right'] : ''),
      children: rightIcon
    })]
  }));
};

const ButtonV2 = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    variant: srcVariant = 'default',
    size = 'medium',
    leftIcon,
    rightIcon,
    nonActive = false,
    hasNotice = false,
    isLoading = false,
    fullWidth = false,
    className = '',
    classNames = {},
    children
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  const variantClasses = useMemo(() => {
    const variants = Array.isArray(srcVariant) ? srcVariant : [srcVariant];
    return variants.filter(Boolean).map(variant => styles[`button--${variant}`]);
  }, [srcVariant]);
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    ref: ref,
    className: clsx(styles.button, styles.buttonV2, ...variantClasses, nonActive ? styles[`button--nonActive`] : '', styles[`buttonV2--${size}`], hasNotice ? styles[`button--notice`] : '', fullWidth && styles['button--fullWidth'], className)
  }, props), {}, {
    children: [leftIcon && /*#__PURE__*/_jsx("span", {
      className: styles.icon,
      children: leftIcon
    }), isLoading ? /*#__PURE__*/_jsx(CircularProgress, {
      size: 16,
      color: "inherit"
    }) : children ? /*#__PURE__*/_jsx("span", {
      className: clsx(styles.label, classNames.label),
      children: children
    }) : null, rightIcon && /*#__PURE__*/_jsx("span", {
      className: clsx(styles.icon, classNames.icon),
      children: rightIcon
    })]
  }));
});
ButtonV2.displayName = 'Button';
export default Button;
export { ButtonV2 };